import React from "react";

const ContactoPage = () => {
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow mt-6 mb-12">
            <h1 className="text-3xl font-bold text-brand-blue mb-4">Contacto</h1>
            <p className="text-gray-700">
                Si tienes preguntas, sugerencias o estás interesado en colaborar con nosotros,
                puedes escribirnos a:
            </p>
            <p className="mt-4 font-semibold text-brand-blue">hola@reformista.net</p>
        </div>
    );
};

export default ContactoPage;
